import type { PageList } from '@omnia/ui/src/lib/services/models/pagelist-models'
import { NavigationService } from '@omnia/ui/src/lib/services/navigation.service'
import { Pages } from '../../pages/pages'
import type { MemberSubPages } from './models/pages'
import { PagesEnum } from './models/pages'

class CineColombiaNavigationService extends NavigationService<PagesEnum, MemberSubPages> {
    protected getOverrideSiteIdPages(): Array<keyof PagesEnum> {
        return [] // TODO:
    }

    protected getPages(): PageList<PagesEnum, MemberSubPages> {
        return Pages
    }

    public constructor() {
        super(new PagesEnum())
    }

    public isCurrentPage(pageKey: keyof PagesEnum): boolean {
        return this.getCurrentPage() === pageKey
    }

    public get PagesKeys() {
        return new PagesEnum()
    }

    public goTo(url: string, newTab: boolean = false) {
        if (url.startsWith(window.origin)) {
            url = url.substring(window.origin.length)
        }

        super.goTo(url, newTab)
    }
}

export const navigationService = new CineColombiaNavigationService()
